(function () {
  'use strict';

  function initMasaruSeoGuide(guide) {
    if (guide.dataset.masaruSeoInitialized === 'true') return;

    var button = guide.querySelector('[data-masaru-seo-toggle]');
    var content = guide.querySelector('[data-masaru-seo-content]');

    if (!button || !content) return;

    guide.dataset.masaruSeoInitialized = 'true';
    content.hidden = true;
    button.hidden = false;
    button.setAttribute('aria-expanded', 'false');
    button.textContent = 'อ่านคู่มือฉบับเต็ม';

    button.addEventListener('click', function () {
      var isExpanded = button.getAttribute('aria-expanded') === 'true';
      var nextExpanded = !isExpanded;

      content.hidden = !nextExpanded;
      button.setAttribute('aria-expanded', String(nextExpanded));
      button.textContent = nextExpanded
        ? 'ย่อเนื้อหา'
        : 'อ่านคู่มือฉบับเต็ม';
    });
  }

  function initAllMasaruSeoGuides(root) {
    var scope = root || document;
    var guides = scope.querySelectorAll('[data-masaru-seo-guide]');

    guides.forEach(initMasaruSeoGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllMasaruSeoGuides(document);
    });
  } else {
    initAllMasaruSeoGuides(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllMasaruSeoGuides(event.target);
  });
})();
